// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
/* Starter Custom Code - End */

export interface QuickOrderPageContainerStyles {
    container?: GridContainerProps;
    firstGridItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    secondGridItem?: GridItemProps;
    thirdGridItem?: GridItemProps;
    thirdGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
}

export const quickOrderPageContainerStyles: QuickOrderPageContainerStyles = {};

/**
 * @deprecated Use quickOrderPageContainerStyles instead.
 */
export const viewStyles = quickOrderPageContainerStyles;

const styles = quickOrderPageContainerStyles;

const QuickOrderPageContainer = ({ id }: WidgetProps) => {
    return (
        <OrderLayout id={id} /> // Starter Custom Code
    );
};

const widgetModule: WidgetModule = {
    component: QuickOrderPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
